/* ============================================================================
   Sixth Man - scroll loading for the collection grid.

   REPLACES the theme's "View More" button, which was BROKEN: its handler
   loadMoreProducts() referenced load_more_btn, load_more_spinner and next_url,
   and all three are undefined, so every click threw a ReferenceError and did
   nothing. Verified on the live store 2026-08-29.

   This does not reuse that function. It reads the next page URL from
   #product-grid[data-next-url], fetches it, and appends the .sitem tiles -
   the same contract the theme's own markup already exposes.

   Today there is no next page: all 14 published products fit one page, so this
   is a no-op and correctly does nothing. It starts working the moment the
   catalogue outgrows one page - the holiday drop.

   The footer stays reachable: auto-loading stops after MAX_AUTO pages and the
   button is restored so the visitor can choose. Bottomless scroll is a dark
   pattern, and on mobile the footer is where shipping and contact live.
   ============================================================================ */
(function () {
  "use strict";

  var MAX_AUTO = 4;
  var grid = document.getElementById("product-grid");
  if (!grid) return;

  var btnWrap = document.querySelector(".load-more");

  function nextUrl() {
    var u = grid.getAttribute("data-next-url");
    return u && u.trim() ? u.trim() : null;
  }

  // No next page, or no IntersectionObserver: leave the DOM alone.
  // (The dead button is hidden by CSS either way - it never worked.)
  if (!nextUrl() || !("IntersectionObserver" in window)) return;

  var busy = false;
  var pages = 0;

  var sentinel = document.createElement("div");
  sentinel.className = "sm-scroll-sentinel";
  sentinel.setAttribute("aria-hidden", "true");
  grid.parentNode.insertBefore(sentinel, grid.nextSibling);

  var live = document.createElement("p");
  live.className = "visually-hidden";
  live.setAttribute("role", "status");
  live.setAttribute("aria-live", "polite");
  grid.parentNode.insertBefore(live, sentinel);

  function stop(restoreButton) {
    io.disconnect();
    sentinel.classList.remove("is-loading");
    if (restoreButton && btnWrap) btnWrap.classList.add("sm-show-load-more");
  }

  function load() {
    var url = nextUrl();
    if (busy || !url) return;
    busy = true;
    sentinel.classList.add("is-loading");

    fetch(url, { credentials: "same-origin" })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var incoming = doc.getElementById("product-grid");
        if (!incoming) throw new Error("no #product-grid in fetched page");

        var tiles = incoming.getElementsByClassName("sitem");
        var count = tiles.length;
        var frag = document.createDocumentFragment();
        while (tiles.length) frag.appendChild(document.importNode(tiles[0], true));
        grid.appendChild(frag);

        grid.setAttribute("data-next-url", incoming.getAttribute("data-next-url") || "");

        pages++;
        busy = false;
        sentinel.classList.remove("is-loading");
        live.textContent = count + " more products loaded.";
        history.replaceState(null, "", url);

        if (window.lazySizes && window.lazySizes.autoSizer) window.lazySizes.autoSizer.checked();

        if (!nextUrl()) { stop(false); sentinel.remove(); }
        else if (pages >= MAX_AUTO) stop(true);
      })
      .catch(function (err) {
        if (window.console) console.warn("[sm-grid]", err);
        busy = false;
        stop(true);          // fail open: give the visitor a control back
        sentinel.remove();
      });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) load(); });
  }, { rootMargin: "600px" });

  io.observe(sentinel);
})();
